<script>
import baseList from "@/views/components/base/baseList.vue";

export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      table: {
        mname: "weappVersion",
        key: "id",
        url: {
          list: "/admin/system/mobileVersion/list",
          del: "/admin/system/mobileVersion",
        },
        output: false,
        order: "id",
      },
      menus: [
        {
          label: "后台版本",
          name: "version_list",
          auth: "",
        },
        {
          label: "移动版本",
          name: "version_weapp_list",
          auth: "",
        },
      ],
      actions: [
        {
          label: "新增版本",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "版本名称",
          KeyEnter: this.search,
          name: "versionName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "版本名称",
          key: "versionName",
          minWidth: 160,
          align: "left",
        },
        {
          title: "操作",
          align: "center",
          width: 260,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {},
        },
      ],
    };
  },
  created() {},
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
      }
      this.selected = ids_arr.join(",");
    },
    toAdd() {
      $utils.url.push({ name: "version_weapp_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "version_weapp_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>
<style scoped></style>
